module.exports = __webpack_public_path__ + "static/media/Matheson Street, Healdsburg, CA5.0949c0e7.jpg";